import React from "react";
import DrawerMenu from "react-modern-drawer";
import CloseBtn from "../../../../assets/images/close-drawer.svg";
import PutUpForSaleForm from "./PutUpForSaleForm";
import PdfViewer from "../../../PdfViewer";
import { wrapInDrawer } from "../../../../utils/methods";

interface SaleDrawerProps {
  edit: boolean;
  open: boolean;
  loading: boolean;
  selectedRowSale: any;
  serviceDescription: string;
  onContractSelected: boolean;
  onDemandSelected: boolean;
  onContractPrice: string;
  onDemandPrice: string;
  typeOptions: any[];
  type: string;
  saleTouched: boolean;
  aggrementAccepted: {
    on_contract: boolean;
    on_demand: boolean;
  };
  isDBPrice: {
    onDemand: boolean;
    onContract: boolean;
  };
  onAggredTermsClick: (_: string) => void;
  onTypeChange: (value: any) => void;
  handlePutupForSaleClick: () => void;
  handleServiceDescription: (e: any) => void;
  handleOnContractPriceChange: (e: any) => void;
  handleOnDemandPriceChange: (e: any) => void;
  handleOnContractSelected: (e: any) => void;
  handleOnDemandSelected: (e: any) => void;
  acceptAgreementBypass: (agreed?: boolean, type?: string) => void;
  onClose: () => void;

  pdfViewerOpen: boolean;
  handleTermsCloseClick: (e: any) => void;
  aggrementTypeInfo: any;

  lowerDrawer?: boolean;
}

const SaleDrawer: React.FC<SaleDrawerProps> = ({
  open,
  edit,
  acceptAgreementBypass,
  loading,
  onClose,
  selectedRowSale,
  serviceDescription,
  onContractSelected,
  isDBPrice,
  onDemandSelected,
  onContractPrice,
  onDemandPrice,
  typeOptions,
  type,
  saleTouched,
  onTypeChange,
  handlePutupForSaleClick,
  handleServiceDescription,
  handleOnContractPriceChange,
  handleOnDemandPriceChange,
  handleOnContractSelected,
  handleOnDemandSelected,
  aggrementAccepted,
  onAggredTermsClick,
  pdfViewerOpen,
  handleTermsCloseClick,
  aggrementTypeInfo,
  lowerDrawer,
}) => {
  const saleDisabled =
    !serviceDescription ||
    (edit && !saleTouched) ||
    (onContractSelected && (!onContractPrice || parseFloat(onContractPrice) === 0 || !aggrementAccepted.on_contract)) ||
    (onDemandSelected && (!onDemandPrice || parseFloat(onDemandPrice) === 0 || !aggrementAccepted.on_demand)) ||
    (!onContractSelected && !onDemandSelected) ||
    (!onContractPrice && !onDemandPrice);
  const canSellOnDemand = !!selectedRowSale?.verified || !!selectedRowSale?.requested_verification;
  return (
    <>
      {wrapInDrawer(
        <PutUpForSaleForm
          aggrementAccepted={aggrementAccepted}
          isDBPrice={isDBPrice}
          onAggredTermsClick={onAggredTermsClick}
          loading={loading}
          edit={edit}
          type={type}
          onClose={onClose}
          canSellOnDemand={canSellOnDemand}
          onContractSelected={onContractSelected}
          onDemandSelected={onDemandSelected}
          typeOptions={typeOptions}
          onTypeChange={onTypeChange}
          onContractPrice={onContractPrice}
          onDemandPrice={onDemandPrice}
          disabled={!!saleDisabled}
          serviceDescription={serviceDescription}
          handleServiceDescription={handleServiceDescription}
          handleOnContractPriceChange={handleOnContractPriceChange}
          handleOnDemandPriceChange={handleOnDemandPriceChange}
          handlePutupForSaleClick={handlePutupForSaleClick}
          handleOnContractSelected={handleOnContractSelected}
          handleOnDemandSelected={handleOnDemandSelected}
          selectedRowSale={selectedRowSale}
          acceptAgreementBypass={acceptAgreementBypass}
        />,
        open,
        onClose,
        lowerDrawer
      )}
      <PdfViewer cannotAccept open={pdfViewerOpen} onClose={handleTermsCloseClick} aggrementType={aggrementTypeInfo.type} url={aggrementTypeInfo.url} />
    </>
  );
};

export default SaleDrawer;
